import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=bb93d3be"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"
import style0 from "./Configuracion.vue?vue&type=style&index=0&id=bb93d3be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports